import React, {Fragment} from 'react';
import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';
import {useStyles} from './style';
import FormHelperText from '@mui/material/FormHelperText';
import { Grid } from '@mui/material';

export default function FormAutocompletar(props) {
	const classes = useStyles(props);
	return (
		<Fragment key={props.name}>
			{props?.showSelectAutoComplete && (
            <Grid className={classes.grid} key={props.name}>
                <Autocomplete
                    key={props.name}
                    value={props.value}
                    id={props.name}
                    name={props.name}
                    onChange={(_, newValue) => {
                        if(newValue) props.handleChange({ target: {value: newValue?.id, name: props.name, text: newValue?.name} });
                        else props.handleChange({target: {value: '', name: props.name, text:''}});
                    }}
                    disabled={props.disabled}
                    options={props.list || []}
                    noOptionsText="No encontrado"
                    getOptionLabel={(option) => option ? option.name : option}
                    defaultValue={(option) => option ? option.name || option : '' }
                    isOptionEqualToValue={(option, value) => value ? option.id === value.id : false }
                    renderInput={(params) =>
                        <TextField
                            autoFocus={props.autoFocus}
                            id={props.name}
                            name={props.name}
                            {...params} label={`${props.label}`}  className={classes.textField}
                        />
                    }
                />
                {(props.isError) ? <FormHelperText className="Mui-error" id="component-error-text">{props.errorMessages}</FormHelperText> : null }
			</Grid>
		)}
		</Fragment>
	);
}

FormAutocompletar.defaultProps = {
    showSelectAutoComplete: true,
    autoFocus: false,
}